import Component from '../core/Component'
import Scroll, { getScroll } from '../services/Scroll'

export const STATES = {
    READY: 'is-ready',
    ACTIVE: 'is-active'
}

export default class FixedHeader extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        Scroll.on("scroll", this.handleScroll)
        this.check()

        setTimeout(() => {
            this.element.classList.add(STATES.READY)
        }, 0)
    }

    destroy() {
        Scroll.off("scroll", this.handleScroll)
    }

    handleScroll = event => {
        this.check()
    }

    check() {
        const pageYOffset = getScroll().y

        const offsetY = pageYOffset || document.documentElement.scrollTop

        if (offsetY > 50) {
            this.element.classList.add(STATES.ACTIVE)
        } else {
            this.element.classList.remove(STATES.ACTIVE)
        }
    }
}